import qs from "qs";
export function wizardConfigurationToUrlSearchQuery(wizardConfiguration) {
    return qs.stringify(wizardConfiguration, {
        allowDots: true,
        filter: (prefix, value) => (value === null ? "null" : value),
    });
}
//# sourceMappingURL=config.js.map